import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import "./HotelSearchLoadingOverlay.scss";

export const HOTEL_SEARCH_LOADING_MESSAGES = [
  "Still searching the best hotel prices for you…",
  "Comparing rates from multiple suppliers…",
  "Finding stays that match your dates and guests…",
  "Checking free cancellation and meal options…",
  "Almost there — great deals are on the way…",
];

const HotelSearchLoadingOverlay = ({
  visible = false,
  placement = "center",
  messages,
  subtitle,
}) => {
  const activeMessages =
    Array.isArray(messages) && messages.length > 0
      ? messages
      : HOTEL_SEARCH_LOADING_MESSAGES;
  const activeSubtitle =
    subtitle ??
    "Please stay on this page — we're fetching live hotel rates for your trip.";
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!visible) {
      setMessageIndex(0);
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % activeMessages.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [visible, activeMessages.length]);

  if (!visible) {
    return null;
  }

  const message = activeMessages[messageIndex];

  return (
    <div
      className={`hotel-search-loading-overlay hotel-search-loading-overlay--${placement}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="hotel-search-loading-overlay__card">
        <Spin size="large" />
        <p className="hotel-search-loading-overlay__title" key={messageIndex}>
          {message}
        </p>
        <p className="hotel-search-loading-overlay__subtitle">
          {activeSubtitle}
        </p>
      </div>
    </div>
  );
};

export default HotelSearchLoadingOverlay;
